import React from 'react';

import {
    urlResumoInscricao,
} from './services/inscricao-service';
import Footer from './Footer';

class FinalizarInscricao extends React.Component {

    render() {
        return (
            <div className="wrapper">
                <nav className="app-navigation">
                    <section className="container">
                        <a className="app-navigation-title" href="/">
                            <h1 className="app-title">Fórum Gaúcho de Aprendizagem Profissional - FOGAP</h1>
                        </a>
                    </section>
                </nav>
                <div className="container app-body" style={{ paddingBottom: 48 }}>
                    <div className="row">
                        <div className="column">
                            <h5>Sua inscrição foi finalizada com sucesso.</h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <a className="button button-primary" style={{ marginRight: 16 }} target="_blank" href={urlResumoInscricao(this.props.match.params.token_inscricao, true)}>Baixar comprovante</a>
                            <input className="button button-primary" type="button" value="Nova inscrição" onClick={() => this.props.history.push('/inscricao/' + this.props.match.params.evento_id)} />
                        </div>
                    </div>
                </div>
                <footer className="footer">
                    <section className="container">
                        <Footer />
                    </section>
                </footer>
            </div>
        );
    }
}

export default FinalizarInscricao;
